import { render, staticRenderFns } from "./EmergancyPurchase.vue?vue&type=template&id=264e58b0&scoped=true"
import script from "./EmergancyPurchase.vue?vue&type=script&lang=js"
export * from "./EmergancyPurchase.vue?vue&type=script&lang=js"
import style0 from "./EmergancyPurchase.vue?vue&type=style&index=0&id=264e58b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e58b0",
  null
  
)

export default component.exports